export default class HistoryService {
  static $inject = ['$http'];

  constructor(private $http) {
    'ngInject';
  }

  getRequestHistory() {
    return this.$http.get(
      '/aptitude/buyer/BuyerRequestHistoryServiceController/getRequestHistory',
      {
        intercept: true
      }
    );
  }

  getBuyerContractHistory() {
    return this.$http.get(
      '/aptitude/buyer/BuyerContractHistoryServiceController/getContractHistory',
      {
        intercept: true
      }
    );
  }

  getResponseHistory() {
    return this.$http.get(
      '/aptitude/seller/SellerResponseHistoryServiceController/getResponseHistory',
      {
        intercept: true
      }
    );
  }

  getSellerContractHistory() {
    return this.$http.get(
      '/aptitude/seller/SellerContractHistoryServiceController/getContractHistory',
      {
        intercept: true
      }
    );
  }
}
